import { render, staticRenderFns } from "./PrivacyPolicyTerms.vue?vue&type=template&id=108e1a60&"
import script from "./PrivacyPolicyTerms.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports